class NameHelper {
    static capitalize(value) {
        return value && value.length ? value.charAt(0).toUpperCase() + value.slice(1) : value;
    }

    static displayName(person) {
        if (!person) return '';
        const firstname = NameHelper.capitalize(person.firstname) || '';
        const lastname = NameHelper.capitalize(person.lastname) || '';
        const showNickname = person.nickname && person.nickname.trim().toLowerCase() !== (person.firstname || '').trim().toLowerCase();
        const name = showNickname
            ? NameHelper.capitalize(person.nickname) + ' (' + firstname + ') ' + lastname
            : firstname + ' ' + lastname;
        return name.trim();
    }
}

export default NameHelper;
